up.preview('content-spinner', (preview, { useBackdrop = false, hideContent = true }) => {
    const spinnerElement = up.element.createFromHTML('<div class="spinner-border" role="status"></div>');
    const spinnerWrapper: Element = preview.origin ?? preview.fragment;
    
    if (hideContent) {
        for (const child of Array.from(spinnerWrapper.children)) {
            preview.hide(child);
        }
    }
    if (useBackdrop) {
        const backdrop: HTMLElement = up.element.createFromHTML('<div class="spinner__backdrop"></div>');
        backdrop.appendChild(spinnerElement);
        preview.insert(spinnerWrapper.lastElementChild, 'afterend', backdrop);
    } else {
        preview.insert(spinnerWrapper.lastElementChild, 'afterend', spinnerElement);
    }
});